import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  cfg.headers["X-Demo-User"] = localStorage.getItem("vig_user") || "u_public";
  return cfg;
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0]}: ${x.msg}`).join("; ");
  return d || e?.message || "Request failed";
};
